import { isLegacyKBDeleted, isMigrationFailed } from 'knowledge-content-types/KnowledgeBaseV3Service/MigrationTypes';
import * as ActionTypes from '../../actions/ActionTypes';
import { showErrorNotification } from '../../actions/Notifications';
import KnowledgeBaseApi from '../api/KnowledgeBaseApi';
import { convertSCPToLegacyKnowledgeBase } from '../data/KnowledgeBase';
import { selectKnowledgeBase } from '../selectors/knowledgeBaseDetails';
import { isUngatedForKnowledgeBaseV3_1 } from '../../utils/gatesUtils';
import { knowledgeBaseMigrationReport } from '../../migration-handler/singleton/migrationHandler';
export function getKnowledgeBase(knowledgeBaseId) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.FETCH_KNOWLEDGE_BASE_PENDING
    });
    if (!isUngatedForKnowledgeBaseV3_1(getState().auth.gates)) {
      return KnowledgeBaseApi.get().then(knowledgeBases => dispatch({
        type: ActionTypes.FETCH_KNOWLEDGE_BASE_SUCCESS,
        payload: {
          requestedKnowledgeBaseId: knowledgeBaseId,
          knowledgeBases
        }
      }), error => {
        dispatch(showErrorNotification('displayKnowledgeBase'));
        dispatch({
          type: ActionTypes.FETCH_KNOWLEDGE_BASE_ERROR,
          error
        });
      });
    }
    return knowledgeBaseMigrationReport().then(({
      new: newKBs,
      legacy,
      migrated
    }) => dispatch({
      type: ActionTypes.FETCH_KNOWLEDGE_BASE_SUCCESS,
      payload: {
        requestedKnowledgeBaseId: knowledgeBaseId,
        knowledgeBases: {
          objects: [...newKBs.map(({
            knowledgeBase
          }) => convertSCPToLegacyKnowledgeBase(knowledgeBase)), ...legacy.map(({
            knowledgeBase
          }) => knowledgeBase), ...migrated.flatMap(({
            legacyKnowledgeBase,
            migration,
            scpKnowledgeBase
          }) => {
            if (isMigrationFailed(migration.status)) {
              return [legacyKnowledgeBase];
            } else if (isLegacyKBDeleted(migration.status)) {
              return [convertSCPToLegacyKnowledgeBase(scpKnowledgeBase)];
            } else {
              return [convertSCPToLegacyKnowledgeBase(scpKnowledgeBase), legacyKnowledgeBase];
            }
          })]
        }
      }
    }), error => {
      dispatch(showErrorNotification('displayKnowledgeBase'));
      dispatch({
        type: ActionTypes.FETCH_KNOWLEDGE_BASE_ERROR,
        error
      });
    });
  };
}
export function updateKnowledgeBaseTranslations(data) {
  return (dispatch, getState) => {
    const knowledgeBase = selectKnowledgeBase(getState());
    dispatch({
      type: ActionTypes.UPDATE_KNOWLEDGE_BASE_PENDING
    });
    return KnowledgeBaseApi.update(knowledgeBase.id, {
      translatedContent: data.toJS()
    }).then(res => dispatch({
      type: ActionTypes.UPDATE_KNOWLEDGE_BASE_SUCCESS,
      payload: res
    }), error => dispatch({
      type: ActionTypes.UPDATE_KNOWLEDGE_BASE_ERROR,
      error
    }));
  };
}